'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _colorManipulator = require('@material-ui/core/styles/colorManipulator');
var _MenuItem = require('@material-ui/core/MenuItem');
var _MenuItem2 = _interopRequireDefault(_MenuItem);
var _Select = require('@material-ui/core/Select');
var _Select2 = _interopRequireDefault(_Select);
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
var _reactI18next = require('react-i18next');
var _manageWorkshopState = require('./manageWorkshopState');
var _manageWorkshopState2 = _interopRequireDefault(_manageWorkshopState);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _numbers = require('../../helpers/numbers');
var _CustomModal = require('../CustomModal');
var _CustomModal2 = _interopRequireDefault(_CustomModal);
var _SpeakerModalContent = require('../SpeakerModalContent');
var _SpeakerModalContent2 = _interopRequireDefault(_SpeakerModalContent);
var _dates = require('../../helpers/dates');
var _CategoryBadges = require('../CategoryBadges');
var _CategoryBadges2 = _interopRequireDefault(_CategoryBadges);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var defaultWorkshopTextColor = '#FFFFFF';
var defaultWorkshopColor = '#2A315A';
var defaultWorkshopAccentColor = '#F5A623';
var leftSideWidth = 7;
var smallLeftSideWidth = 6;
var styles = {
  WorkshopRectangles: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    maxWidth: '60rem',
    width: '100%',
    margin: 'auto'
  },
  stepper: {
    textAlign: 'center',
    width: function width(_ref) {
      var responsiveMode = _ref.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? 'auto' : '100%';
    },
    flex: 'none',
    '& .date': {
      position: 'relative',
      display: function display(_ref2) {
        var responsiveMode = _ref2.responsiveMode;
        return responsiveMode === _ResponsiveModes.DESKTOP ? 'flex' : 'inline-flex';
      },
      height: function height(_ref3) {
        var responsiveMode = _ref3.responsiveMode;
        return responsiveMode === _ResponsiveModes.DESKTOP ? leftSideWidth - 1 + 'rem' : smallLeftSideWidth - 1 + 'rem';
      },
      width: function width(_ref4) {
        var responsiveMode = _ref4.responsiveMode;
        return responsiveMode === _ResponsiveModes.DESKTOP ? leftSideWidth + 'rem' : smallLeftSideWidth + 'rem';
      },
      background: function background(_ref5) {
        var workshopColor = _ref5.otherProperties.workshopColor;
        return workshopColor || defaultWorkshopColor;
      },
      flexDirection: 'column',
      justifyContent: 'center',
      color: function color(_ref6) {
        var workshopTextColor = _ref6.otherProperties.workshopTextColor;
        return (0, _colorManipulator.fade)(workshopTextColor || defaultWorkshopTextColor, 0.7);
      },
      fontWeight: 'normal',
      cursor: 'pointer',
      margin: '2rem 1rem 1rem 1rem',
      '&.active': {
        color: function color(_ref7) {
          var workshopAccentColor = _ref7.otherProperties.workshopAccentColor;
          return workshopAccentColor || defaultWorkshopAccentColor;
        }
      },
      '&::before': {
        content: '""',
        width: '100%',
        height: '1rem',
        background: function background(_ref8) {
          var workshopColor = _ref8.otherProperties.workshopColor;
          return (0, _colorManipulator.lighten)(workshopColor || defaultWorkshopColor, 0.2);
        },
        position: 'absolute',
        top: '-1rem',
        left: 0
      },
      '&.active::before': {
        background: function background(_ref9) {
          var workshopAccentColor = _ref9.otherProperties.workshopAccentColor;
          return workshopAccentColor || defaultWorkshopAccentColor;
        }
      },
      '& .day': {
        fontSize: 'medium'
      },
      '& .month': {
        fontSize: 'medium'
      }
    }
  },
  workshopsWrapper: {
    paddingTop: '1rem'
  },
  rectangles: {
    position: 'relative',
    margin: '1rem',
    marginLeft: function marginLeft(_ref10) {
      var responsiveMode = _ref10.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? 0 : '1rem';
    },
    paddingLeft: '1rem',
    flex: 1,
    '&::before': {
      content: '""',
      height: '100%',
      width: '75%',
      position: 'absolute',
      left: 0,
      top: 0,
      background: function background(_ref11) {
        var workshopColor = _ref11.otherProperties.workshopColor;
        return (0, _colorManipulator.darken)(workshopColor || defaultWorkshopColor, 0.2);
      }
    }
  },
  categoryWrapper: {
    display: 'flex',
    justifyContent: 'center'
  },
  workshop: {
    fontSize: 'small',
    background: function background(_ref12) {
      var workshopColor = _ref12.otherProperties.workshopColor;
      return workshopColor || defaultWorkshopColor;
    },
    marginBottom: '1rem',
    padding: '1rem',
    color: function color(_ref13) {
      var workshopTextColor = _ref13.otherProperties.workshopTextColor;
      return workshopTextColor || defaultWorkshopTextColor;
    },
    position: 'relative',
    display: 'flex',
    maxWidth: 'calc(100% - 2rem)',
    flexDirection: function flexDirection(_ref14) {
      var responsiveMode = _ref14.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? 'column-reverse' : 'row';
    },
    '& .left-info': {
      flex: 1
    },
    '& .time-and-location': {
      margin: '-0.5rem -1rem 0 0',
      background: function background(_ref15) {
        var workshopColor = _ref15.otherProperties.workshopColor;
        return (0, _colorManipulator.lighten)(workshopColor || defaultWorkshopColor, 0.2);
      },
      textAlign: 'right',
      width: function width(_ref16) {
        var responsiveMode = _ref16.responsiveMode;
        return responsiveMode === _ResponsiveModes.MOBILE ? 'auto' : '13rem';
      },
      padding: '0.5rem 1rem',
      alignSelf: function alignSelf(_ref17) {
        var responsiveMode = _ref17.responsiveMode;
        return responsiveMode === _ResponsiveModes.MOBILE ? 'flex-end' : 'flex-start';
      }
    },
    '& .time': {
      margin: 0
    },
    '& .location': {
      textTransform: 'uppercase',
      fontWeight: 'normal',
      margin: 0,
      overflowWrap: 'break-word'
    },
    '& .speaker-wrapper': {
      width: '100%',
      '& .speaker-list-title-wrapper': {
        display: 'flex',
        '& .speaker-list-title': {
          alignSelf: 'flex-start',
          marginTop: 16,
          color: function color(_ref18) {
            var workshopAccentColor = _ref18.otherProperties.workshopAccentColor;
            return workshopAccentColor || defaultWorkshopAccentColor;
          },
          fontSize: 'medium',
          fontStyle: 'italic'
        }
      },
      '& .speaker-list': {
        margin: '0 -1rem',
        '& .speaker-info': {
          textAlign: 'center',
          margin: '1rem',
          minWidth: '10rem',
          width: '10rem',
          display: 'inline-block',
          verticalAlign: 'top',
          '& .picture': {
            height: '3rem',
            width: '3rem',
            objectFit: 'cover',
            borderRadius: '5rem',
            margin: '0 auto',
            cursor: 'pointer'
          },
          '& .speaker-name': {
            margin: '0.4rem 0',
            color: function color(_ref19) {
              var workshopAccentColor = _ref19.otherProperties.workshopAccentColor;
              return workshopAccentColor || defaultWorkshopAccentColor;
            },
            overflowWrap: 'break-word'
          },
          '& .speaker-secondary-info': {
            margin: '0.3rem 0',
            fontSize: 'small',
            overflowWrap: 'break-word'
          }
        }
      }
    },
    '& .workshop-name': {
      width: '100%',
      fontWeight: 'bold',
      fontSize: 'large',
      color: function color(_ref20) {
        var workshopAccentColor = _ref20.otherProperties.workshopAccentColor;
        return workshopAccentColor || defaultWorkshopAccentColor;
      },
      margin: '16px 0'
    },
    '& .description': {
      '& img': {
        maxWidth: '100%',
        objectFit: 'contain'
      }
    },
    '& .description-container': {
      width: '100%',
      paddingRight: '1rem',
      boxSizing: 'border-box'
    },
    '& .more-info-button': {
      cursor: 'pointer',
      fontWeight: 'normal'
    }
  }
};

// Show complete description from each speaker
var maxLetters = Number.MAX_SAFE_INTEGER;
var WorkshopRectangles = function (_Component) {
  _inherits(WorkshopRectangles, _Component);
  function WorkshopRectangles(props) {
    _classCallCheck(this, WorkshopRectangles);
    var _this = _possibleConstructorReturn(this, (WorkshopRectangles.__proto__ || Object.getPrototypeOf(WorkshopRectangles)).call(this, props));
    _this.handleClose = function () {
      _this.setState({
        currentSId: 0
      });
    };
    _this.showModal = function (id) {
      _this.setState({
        currentSId: id
      });
    };
    _this.isExpanded = function (workshop, expanded) {
      return expanded.indexOf(workshop.id) > -1;
    };
    _this.canExpand = function (workshop) {
      return !!workshop.description && workshop.description.length >= maxLetters;
    };
    _this.getDescription = function (workshop, expanded) {
      if (_this.isExpanded(workshop, expanded) || !_this.canExpand(workshop)) {
        return workshop.description;
      } else {
        return workshop.description.substring(0, maxLetters) + '...';
      }
    };
    _this.state = {
      currentSId: 0
    };
    return _this;
  }
  _createClass(WorkshopRectangles, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var i18n = this.props.i18n;
      var _props = this.props,
        classes = _props.classes,
        byDate = _props.byDate,
        categories = _props.categories,
        currentDate = _props.currentDate,
        currentCategory = _props.currentCategory,
        setCurrentDate = _props.setCurrentDate,
        setCurrentCategory = _props.setCurrentCategory,
        expanded = _props.expanded,
        toggleExpanded = _props.toggleExpanded,
        entities = _props.entities,
        pagination = _props.pagination,
        cssProperties = _props.cssProperties,
        otherProperties = _props.otherProperties,
        otherData = _props.otherData,
        t = _props.t;
      var showFilters = otherProperties.showFilters,
        showCategories = otherProperties.showCategories;
      var isFetching = pagination.isFetching;
      var workshops = !!byDate && byDate[currentDate];
      var speakers = entities.speakers;
      var event = entities.events[Object.keys(entities.events)[0]];
      var modalPictureStyle = void 0,
        modalSpeaker = void 0;
      if (!!this.state.currentSId && !!entities.speakers && !!entities.speakers[this.state.currentSId]) {
        modalSpeaker = entities.speakers[this.state.currentSId];
        modalPictureStyle = {
          backgroundImage: 'url(' + (modalSpeaker.picture.filename ? modalSpeaker.picture.small : 'https://s3.amazonaws.com/eventtia-composer/assets/images/icons/avatar.png') + ')'
        };
      }
      return _react2.default.createElement('div', {
        className: classes.workshopsWrapper,
        style: cssProperties
      }, !isFetching && !!showFilters && _react2.default.createElement('div', {
        className: classes.categoryWrapper
      }, _react2.default.createElement(_Select2.default, {
        value: currentCategory,
        displayEmpty: true,
        name: 'workshopCategory',
        className: classes.filter,
        onChange: setCurrentCategory
      }, _react2.default.createElement(_MenuItem2.default, {
        value: ''
      }, _react2.default.createElement('span', {
        className: classes.filterPlaceholder
      }, t('workshops.category'))), !!categories && Object.keys(categories).map(function (key) {
        return _react2.default.createElement(_MenuItem2.default, {
          key: key,
          value: key
        }, categories[key].name);
      }))), _react2.default.createElement('div', {
        className: classes.WorkshopRectangles
      }, !isFetching && _react2.default.createElement('div', {
        className: classes.stepper
      }, !!byDate && Object.keys(byDate).sort().map(function (date) {
        return _react2.default.createElement('div', {
          key: date,
          className: 'date ' + (date === currentDate ? 'active' : ''),
          onClick: function onClick() {
            return setCurrentDate(date);
          }
        }, _react2.default.createElement('div', {
          className: 'day'
        }, (0, _moment2.default)(date).format(_numbers.DAY_FORMATS[i18n.language] || 'Do')), _react2.default.createElement('div', {
          className: 'month'
        }, (0, _moment2.default)(date).format('MMMM')));
      })), isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        size: 50
      }) : !!workshops && !!workshops.length ? _react2.default.createElement('div', {
        className: classes.rectangles
      }, !!this.state.currentSId && _react2.default.createElement(_CustomModal2.default, {
        onClose: this.handleClose
      }, _react2.default.createElement(_SpeakerModalContent2.default, {
        speaker: modalSpeaker,
        imgStyle: modalPictureStyle
      })), workshops.map(function (workshop) {
        return _react2.default.createElement('div', {
          className: classes.workshop,
          key: workshop.id
        }, _react2.default.createElement('div', {
          className: 'left-info'
        }, _react2.default.createElement('h2', {
          className: 'workshop-name'
        }, workshop.name), !!showCategories && _react2.default.createElement(_CategoryBadges2.default, {
          categories: categories,
          workshopCategories: workshop.workshopCategories
        }), _react2.default.createElement('div', {
          className: 'description-container'
        }, _react2.default.createElement('div', {
          className: 'description ql-editor',
          dangerouslySetInnerHTML: {
            __html: _this2.getDescription(workshop, expanded)
          }
        }), _this2.canExpand(workshop) && _react2.default.createElement('a', {
          className: 'more-info-button',
          onClick: function onClick() {
            return toggleExpanded(workshop.id);
          }
        }, _this2.isExpanded(workshop, expanded) ? t('text.less_info') : t('text.more_info'))), _react2.default.createElement('div', {
          className: 'speaker-wrapper'
        }, _react2.default.createElement('div', {
          className: 'speaker-list-title-wrapper'
        }, !!workshop.speakers.length && _react2.default.createElement('p', {
          className: 'speaker-list-title'
        }, workshop.speakers.length > 1 ? t('workshops.speakers') : t('workshops.speaker'))), _react2.default.createElement('div', {
          className: 'speaker-list'
        }, !!workshop.speakers.length && workshop.speakers.map(function (current_speaker) {
          var _speakers$current_spe = speakers[current_speaker.id],
            id = _speakers$current_spe.id,
            picture = _speakers$current_spe.picture,
            fullName = _speakers$current_spe.fullName,
            position = _speakers$current_spe.position,
            twitter = _speakers$current_spe.twitter,
            linkedin = _speakers$current_spe.linkedin,
            company = _speakers$current_spe.company;
          return _react2.default.createElement('div', {
            className: 'speaker-info',
            key: id
          }, _react2.default.createElement('img', {
            onClick: function onClick() {
              _this2.showModal(id);
            },
            className: 'picture',
            src: picture.filename ? picture.small : 'https://s3.amazonaws.com/eventtia-composer/assets/images/icons/avatar.png'
          }), _react2.default.createElement('p', {
            className: 'speaker-name'
          }, fullName), _react2.default.createElement('p', {
            className: 'speaker-secondary-info'
          }, company), _react2.default.createElement('p', {
            className: 'speaker-secondary-info'
          }, position));
        })))), _react2.default.createElement('div', {
          className: 'time-and-location'
        }, _react2.default.createElement('p', {
          className: 'time'
        }, (0, _dates.workshopDateWithTimezone)(workshop, event, otherData, t)), _react2.default.createElement('p', {
          className: 'location'
        }, workshop.location)));
      })) : _react2.default.createElement('h3', null, 'No activities :(')));
    }
  }]);
  return WorkshopRectangles;
}(_react.Component);
exports.default = (0, _manageWorkshopState2.default)()((0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(WorkshopRectangles)));